/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificacionesDto } from '../../models/notificaciones-dto';

export interface NotificacionesControllerObtenerConfiguracionNotificaciones$Params {
}

export function notificacionesControllerObtenerConfiguracionNotificaciones(http: HttpClient, rootUrl: string, params?: NotificacionesControllerObtenerConfiguracionNotificaciones$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificacionesDto>> {
  const rb = new RequestBuilder(rootUrl, notificacionesControllerObtenerConfiguracionNotificaciones.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificacionesDto>;
    })
  );
}

notificacionesControllerObtenerConfiguracionNotificaciones.PATH = '/api/notificaciones/configuracion-notificaciones';
